export enum UnitEnum {
    G = 'g',
    PIECE = 'Stück',
    UNIT = 'Einheit',
    PAIR = 'Paar'
}
